import CustomDetailPage from './CustomDetailPage';

export const CustomDetailPageConfig = {
  routes: [
    {
      path: '/pages/custom/detail',
      exact: true,
      component: CustomDetailPage,
    },
  ],
};
